import { Component, computed, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CurrencyPipe, DecimalPipe } from '@angular/common';
import { HandwerkerSucheDto } from '../../../core/models/handwerker-suche.model';
import { VerifizierungsBadgeComponent } from '../verifizierung-badge/verifizierung-badge.component';

/** S5 — höchstens so viele Gewerk-Labels direkt anzeigen, Rest als „+N". */
const MAX_SICHTBARE_GEWERKE = 2;

@Component({
  selector: 'app-handwerker-karte',
  standalone: true,
  imports: [RouterLink, CurrencyPipe, DecimalPipe, VerifizierungsBadgeComponent],
  templateUrl: './handwerker-karte.component.html',
  styleUrl: './handwerker-karte.component.scss',
  host: { ngSkipHydration: 'true' },
})
export class HandwerkerKarteComponent {
  readonly handwerker = input.required<HandwerkerSucheDto>();

  /** Monogramm-Initiale für den Bild-Fallback — nie ein grauer Leerblock. */
  readonly initial = computed(() => {
    const v = this.handwerker().vorname?.trim();
    return v ? v.charAt(0).toUpperCase() : '?';
  });

  /** Erste {@link MAX_SICHTBARE_GEWERKE} Gewerke; der Rest wird gekappt (S5). */
  readonly sichtbareGewerke = computed(() =>
    this.handwerker().gewerke.slice(0, MAX_SICHTBARE_GEWERKE),
  );

  /** Anzahl der nicht angezeigten Gewerke (0 = alle sichtbar). */
  readonly weitereGewerke = computed(() =>
    Math.max(0, this.handwerker().gewerke.length - MAX_SICHTBARE_GEWERKE),
  );
}
